import { Component } from '@angular/core';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { FormValuesService } from '../services/form-values/form-values.service';
import { CustomerEditService } from '../services/customer-edit/customer-edit.service';
import { linksNoSubNav } from '../app.component';

export interface Kid {
  geburtsdatum   : string,
  geschlechtText : string,
  kinderId       : string,
  nachname       : string,
  vorname        : string
}

export interface Person {
  anrede       : string,
  berufsgruppe : string,
  bundesland   : string,
  email        : string,
  geburtsdatum : string,
  nachname     : string,
  ort          : string,
  personenId   : string,
  plz          : string,
  strasse_nr   : string,
  telefon      : string,
  telefonMobil : string,
  vorname      : string,
}

export interface Contract {
  beitragJahr  : number,
  gesellschaft : string,
  personenId   : string,
  vGattungText : string,
  vertragsId   : string,
  vsnr         : string,
}

export interface Customer {
  beziehungsstatus   : string,
  beziehungsstatusId : number,
  date               : string,
  datensatzId        : string,
  kinderIntro        : Array<Kid>,
  panel              : boolean,
  personenIntro      : Array<Person>,
  vertragsIntro      : Array<Contract>
}

@Component({
  selector: 'app-customer-overview',
  templateUrl: './customer-overview.component.html',
  styleUrls: ['./customer-overview.component.css']
})
export class CustomerOverviewComponent {
  
  linksNoSubNav = linksNoSubNav;

  fileToUpload  : File    = null;
  hideKids      : boolean = true;
  
  private customers : Array<Customer>;
  
  imgFileNames : Array<string>= [
    "allianz",
    "alteleipziger",
    "arag",
    "axa",
    "barmenia",
    "basler",
    "bayerische",
    "canadalife",
    "concordia",
    "condor",
    "conti",
    "dak",
    "dbv",
    "dialog",
    "ergo",
    "europa",
    "generali",
    "gothaer",
    "hansemerkur",
    "hdi",
    "inter",
    "interrisk",
    "lv1871",
    "lvm",
    "nuernberger",
    "signaliduna",
    "stuttgarter",
    "swisslife",
    "tmpLogo",
    "universa",
    "volkswohlbund",
    "vpv",
    "vuLogo",
    "wuerttembergische",
    "wwk",
    "zurich"
  ]
 
  constructor( 
    private router: Router, 
    private customerEditService : CustomerEditService 
  ) {
    /* localStorage
    this.customers = customerEditService.getCustomers();
    */
    this.customers = customerEditService.getCustomerShortList()
    /*
    .subscribe( (data:any) => {
      this.customers = [];
      data.result[0].DatensaetzeShortList.forEach( (customer) => {
        customer["panel"] = false;
        customer["date"] = new Date();
        this.customers.push(customer);  
      });
    });
    
     we got a better way to get this data for now
    .then( ( customersArray : Array<any> ) => {  
      this.customers = customersArray;
    }, error => {
      console.log(error);
    });
    */
  }
  
  ngOnDestroy() {
    this.toggleAllPanel();
  }

  private addNewCustomer() {
    this.router.navigate([linksNoSubNav.kundenbearbeitung, {id:'neuer Kunde'}] );    
  }
  
  private deleteCustomer(index) {
    this.customerEditService.deleteCustomer(index);
  }

  private toggleAllPanel(){
    if(this.customers){
      this.customers.forEach(customer => {
        customer.panel = false;
      });
    }  
  }
  
  private togglePanel(index) {
    this.customers[index].panel = !this.customers[index].panel;
    if( !this.hideKids ) {
      this.hideKids = true;
    }
  }
  
  private toggleKids(){
    this.hideKids = false;
  }
  
  //TODO
  private changeAvatar(img,index) {
    this.customerEditService.changeAvatar( img,index  )
  }
  
  private ageCalc(birth){   
    let dt1 = new Date( birth.split(".")[1] + "." + birth.split(".")[0] + "." + birth.split(".")[2] );
    let dt2 = new Date();
    
    return dt2.getFullYear() - dt1.getFullYear();
  }
  
  private getInsuranceImage(insuranceStr: string){
    let source : string = "assets/img/versicherungen/";
    
    this.imgFileNames.some(element => {
      if(insuranceStr.toLocaleLowerCase().replace(/\s+/g, '').includes(element)){
        source += element;
        return true
      }
    });
    source += ".png";
    
    if(source.length === 30){
      source = "assets/img/versicherungen/placeholder.png";
    }
    
    return source;
  }
 
}


// WEBPACK FOOTER //
// ./src/app/customer-overview/customer-overview.component.ts